module.exports = __webpack_public_path__ + "static/media/smilingOldMan.61015155.png";